import { render, staticRenderFns } from "./SystemMain.vue?vue&type=template&id=0acea2f9&scoped=true"
import script from "./SystemMain.vue?vue&type=script&lang=js"
export * from "./SystemMain.vue?vue&type=script&lang=js"
import style0 from "./SystemMain.vue?vue&type=style&index=0&id=0acea2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acea2f9",
  null
  
)

export default component.exports